import logoDark from '@/assets/logo-dark.png'

/**
 * Full-page logo splash: shown while the session is restored on the sign-in
 * route and as the Suspense fallback while the sign-in chunk itself loads, so
 * the two states are indistinguishable to the user.
 */
export function LogoSplash() {
  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <img src={logoDark} alt="Inovio" className="h-8 animate-pulse" />
    </div>
  )
}
